<ion-content #pageTop class="background">
  <div class="header-page">
    <app-header-not-buttons></app-header-not-buttons>

    <app-title-three title="Actualizar Dirección"></app-title-three>
  </div>

  <form [formGroup]="updateForm">
    <ion-grid class="form-data">
      <ion-row>
        <!-- Provincia -->
        <ion-col size="12">
          <ion-item>
            <ion-label>{{ "Provincia" | translate }} *</ion-label>
            <ionic-selectable
              #state_id
              formControlName="state_id"
              id="state_id"
              item-content
              itemValueField="id"
              itemTextField="name"
              [items]="states"
              [canSearch]="true"
              (onChange)="onStateChange()"
              closeButtonText="Cancelar"
              searchButtonText="Buscar"
            >
            </ionic-selectable>
          </ion-item>
          <div
            class="div message-errors"
            *ngIf="(errorControl.state_id.touched || errorControl.state_id.dirty) && errorControl.state_id.errors"
          >
            <ng-container
              *ngFor="let validation of validationMessages.state_id"
            >
              <div *ngIf="errorControl.state_id.hasError(validation.type)">
                <ion-text color="primary" class="messages-alert"
                  >{{validation.message | translate }}</ion-text
                >
              </div>
            </ng-container>
          </div>
        </ion-col>
        <!-- Localidad -->
        <ion-col size="12">
          <ion-item>
            <ion-label>{{"Localidad" | translate }} *</ion-label>
            <ionic-selectable
              #city
              formControlName="city_id"
              item-content
              itemValueField="id"
              itemTextField="name"
              [items]="cities"
              [canSearch]="true"
              closeButtonText="Cancelar"
              searchButtonText="Buscar"
            >
            </ionic-selectable>
          </ion-item>
          <div
            class="div message-errors"
            *ngIf="(errorControl.city_id.touched || errorControl.city_id.dirty) && errorControl.city_id.errors"
          >
            <ng-container *ngFor="let validation of validationMessages.city_id">
              <div *ngIf="errorControl.city_id.hasError(validation.type)">
                <ion-text color="primary" class="messages-alert"
                  >{{validation.message | translate }}</ion-text
                >
              </div>
            </ng-container>
          </div>
        </ion-col>
        <!-- Institución -->
        <ion-col size="12">
          <ion-item>
            <ion-label position="floating" color="tertiary"
              >Institución *</ion-label
            >
            <ion-input
              formControlName="institution"
              maxlength="50"
              id="institution"
            ></ion-input>
          </ion-item>

          <div
            class="div message-errors"
            *ngIf="(errorControl.institution.touched || errorControl.institution.dirty) && errorControl.institution.errors"
          >
            <ng-container
              *ngFor="let validation of validationMessages.institution"
            >
              <div *ngIf="errorControl.institution.hasError(validation.type)">
                <ion-text color="primary" class="messages-alert"
                  >{{validation.message | translate }}</ion-text
                >
              </div>
            </ng-container>
          </div>
        </ion-col>
        <!-- Input Direcciones -->
        <ion-col size="12">
          <ion-item>
            <ion-label position="floating" color="tertiary"
              >Dirección *</ion-label
            >
            <ion-input
              formControlName="address"
              maxlength="100"
              id="address"
            ></ion-input>
          </ion-item>
          <div
            class="div message-errors"
            *ngIf="(errorControl.address.touched || errorControl.address.dirty) && errorControl.address.errors"
          >
            <ng-container *ngFor="let validation of validationMessages.address">
              <div *ngIf="errorControl.address.hasError(validation.type)">
                <ion-text color="primary" class="messages-alert"
                  >{{validation.message | translate }}</ion-text
                >
              </div>
            </ng-container>
          </div>
        </ion-col>

        <!-- Cod. Postal -->
        <ion-col size="12">
          <ion-item>
            <ion-label position="floating" color="tertiary"
              >Cod. Postal</ion-label
            >
            <ion-input
              formControlName="postal"
              maxlength="8"
              id="postal"
            ></ion-input>
          </ion-item>
          <div
            class="div message-errors"
            *ngIf="(errorControl.postal.touched || errorControl.postal.dirty) && errorControl.postal.errors"
          >
            <ng-container *ngFor="let validation of validationMessages.postal">
              <div *ngIf="errorControl.postal.hasError(validation.type)">
                <ion-text color="primary" class="messages-alert"
                  >{{validation.message | translate }}</ion-text
                >
              </div>
            </ng-container>
          </div>
        </ion-col>

        <!-- Input Observation -->
        <ion-col size="12">
          <ion-item>
            <ion-label position="floating" color="tertiary"
              >Observaciones</ion-label
            >
            <ion-input
              formControlName="observation"
              maxlength="200"
              id="observation"
              (ionChange)="updateCharCount()"
            ></ion-input>
          </ion-item>
          <div class="character-counter">
            {{ currentCharCount }}/200
          </div>
          <div
            class="div message-errors"
            *ngIf="(errorControl.observation.touched || errorControl.observation.dirty) && errorControl.observation.errors"
          >
            <ng-container
              *ngFor="let validation of validationMessages.observation"
            >
              <div *ngIf="errorControl.observation.hasError(validation.type)">
                <ion-text color="primary" class="messages-alert"
                  >{{validation.message | translate }}</ion-text
                >
              </div>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid>
      <ion-row>
        <ion-col size="12" class="buttons">
          <ion-grid>
            <ion-row>
              <ion-col class="center" size="12">
                <button
                  (click)="update()"
                  class="btn-primary-2"
                  id="btn-create"
                >
                  <ion-label>Actualizar</ion-label>
                </button>
              </ion-col>
              <ion-col class="center" size="12">
                <button (click)="closeModal(1)" class="btn-primary btn-close">
                  <ion-label>Cerrar</ion-label>
                </button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
